import { render, staticRenderFns } from "./InfoBuy.vue?vue&type=template&id=09d841cd&scoped=true&"
import script from "./InfoBuy.vue?vue&type=script&lang=js&"
export * from "./InfoBuy.vue?vue&type=script&lang=js&"
import style0 from "./InfoBuy.vue?vue&type=style&index=0&id=09d841cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d841cd",
  null
  
)

export default component.exports